import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Alert, Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { GetVisitRegistrationCalendarSlotDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import momencik from '../../../common/momencik';

interface ExternalVisitBookingDetailsProps {
  slot?: GetVisitRegistrationCalendarSlotDto;
  onHide: () => void;
}

export const ExternalVisitBookingDetails: React.FC<
  ExternalVisitBookingDetailsProps
> = props => {
  return (
    <Modal show={!!props.slot} onHide={props.onHide} centered={true} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Szczegóły zapisu</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="mb-2">
          <Card.Body>
            <Form className="d-grid gap-3">
              <FormRow controlId="examinedName" label="Pacjent">
                <Form.Control
                  type="text"
                  readOnly
                  value={`${props.slot?.firstname || ''} ${
                    props.slot?.surname || ''
                  }`}
                />
              </FormRow>
              <FormRow controlId="examTypeName" label="Typ badania">
                <Form.Control
                  type="text"
                  readOnly
                  value={props.slot?.examTypeName || '-'}
                />
              </FormRow>
              <FormRow controlId="visitDateTime" label="Początek wizyty">
                <Form.Control
                  type="text"
                  readOnly
                  value={momencik(
                    props.slot?.visitDateTime,
                    'YYYY-MM-DD HH:mm',
                  )}
                />
              </FormRow>
              <FormRow controlId="visitTime" label="Okno czasowe (min)">
                <Form.Control
                  type="text"
                  readOnly
                  value={props.slot?.visitTime ?? '-'}
                />
              </FormRow>
            </Form>
          </Card.Body>
        </Card>
        {!props.slot?.mine && (
          <Alert variant="warning">
            Ten zapis został utworzony przez inne konto — możesz go tylko
            zobaczyć, bez możliwości zmiany terminu.
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Zamknij
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
